import { useTranslation } from 'react-i18next'

import { Wallet } from 'components-ref/organisms/wallet'
import { SingleSetting } from 'pages/settings/features/SingleSetting'
import { Chat } from 'pages/settings/features/singleSettingBody/Chat'
import { ChatStrategy } from 'pages/settings/features/singleSettingBody/ChatStrategy'
import { EditWelcomeMessage } from 'pages/settings/features/singleSettingBody/EditWelcomeMessage'
import { LiveStream } from 'pages/settings/features/singleSettingBody/LiveStream'
import { MiniBio } from 'pages/settings/features/singleSettingBody/MiniBio'
import { PayoutSettings } from 'pages/settings/features/singleSettingBody/Payout'
import { Post } from 'pages/settings/features/singleSettingBody/Post'
import { StorySettings } from 'pages/settings/features/singleSettingBody/StorySettings'
import { WelcomeMessage } from 'pages/settings/features/singleSettingBody/WelcomeMessage'
import { GeneralSettings } from 'pages/settings/GeneralSettings'
import { JustCheckboxCards } from 'pages/settings/layout/JustCheckboxCards'
import { Activity } from 'pages/settings/pages/Activity'
import { EditLanguage } from 'pages/settings/pages/EditLanguage'
import { BankInformation } from 'pages/settings/pages/paymentSettings/BankInformation'
import { PaymentFrequency } from 'pages/settings/pages/paymentSettings/PaymentFrequency'
import { PaymentList } from 'pages/settings/pages/paymentSettings/PaymentList'
import { PaymentMethod } from 'pages/settings/pages/paymentSettings/PaymentMethod'
import DAC7 from 'pages/settings/pages/paymentSettings/taxdocumentform/dac7'
import W8Ben from 'pages/settings/pages/paymentSettings/taxdocumentform/w8-ben'
import W9 from 'pages/settings/pages/paymentSettings/taxdocumentform/w9'
import { UploadDocuments } from 'pages/settings/pages/paymentSettings/UploadDocuments'
import { DiscountedBundles } from 'pages/settings/pages/subscriptionOptions/DiscountedBundles'
import { FreeTrial } from 'pages/settings/pages/subscriptionOptions/FreeTrial'
import { PromoCampaigns } from 'pages/settings/pages/subscriptionOptions/PromoCampaigns'
import { SetSubscriptionPrice } from 'pages/settings/pages/subscriptionOptions/SetPrice'
import { SubscriptionOptions } from 'pages/settings/pages/subscriptionOptions/SubscriptionOptions'

export const useSettingsRoutesGeneral = () => {
    const { t } = useTranslation()

    return [
        {
            path: '/settings/general',
            Component: <GeneralSettings />,
            roles: ['fan', 'model'],
            exact: true
        },
        {
            path: '/settings/general/subscription-options',
            Component: <SubscriptionOptions />,
            roles: ['model'],
            exact: true
        },
        {
            path: '/settings/general/subscription-options/set-price',
            Component: <SetSubscriptionPrice />,
            roles: ['model']
        },
        {
            path: '/settings/general/subscription-options/discounted-bundles',
            Component: <DiscountedBundles />,
            roles: ['model']
        },
        {
            path: '/settings/general/subscription-options/promo-campaigns',
            Component: <PromoCampaigns />,
            roles: ['model']
        },
        {
            path: '/settings/general/subscription-options/free-trial-link',
            Component: <FreeTrial />,
            roles: ['model']
        },
        {
            path: [
                {
                    path: '/settings/general/payout-settings',
                    roles: ['model'],
                    props: {
                        section: t('general'),
                        title: t('settings:payoutSettings'),
                        withoutHeaderSwitch: true,
                        withHeaderUnderline: true,
                        body: <PayoutSettings />
                    },
                    exact: true
                },
                {
                    path: '/settings/general/post-settings',
                    roles: ['model'],
                    props: {
                        section: t('general'),
                        title: t('settings:postSettings'),
                        withoutHeaderSwitch: true,
                        body: <Post />
                    }
                },
                {
                    path: '/settings/general/profile-settings/mini-bio',
                    roles: ['model'],
                    props: {
                        section: t('settings:profileSettings'),
                        title: t('miniBio'),
                        body: <MiniBio />
                    }
                },
                {
                    path: '/settings/general/chat-settings',
                    roles: ['model', 'fan'],
                    props: {
                        section: t('general'),
                        title: t('settings:chatSettings'),
                        body: <Chat />,
                        withoutHeaderSwitch: true
                    },
                    exact: true
                },
                {
                    path: '/settings/general/chat-settings/chat-strategy',
                    roles: ['model'],
                    props: {
                        section: t('chat'),
                        title: t('upsellStrategy'),
                        body: <ChatStrategy />,
                        withoutHeaderSwitch: true
                    },
                    exact: true
                },
                {
                    path: '/settings/general/chat-settings/welcome-message',
                    roles: ['model'],
                    props: {
                        section: t('settings:chatSettings'),
                        title: t('welcomeMessage'),
                        body: <WelcomeMessage />
                    }
                },
                {
                    path: '/settings/general/live-stream',
                    roles: ['model'],
                    props: {
                        section: t('general'),
                        title: t('settings:liveStreamSettings'),
                        body: <LiveStream page='cards' />,
                        withoutHeaderSwitch: true
                    },
                    exact: true
                },
                {
                    path: '/settings/general/live-stream/set-price',
                    roles: ['model'],
                    props: {
                        section: t('settings:liveStreamSettings'),
                        title: t('setPrice'),
                        body: <LiveStream page='price' />
                    }
                },
                {
                    path: '/settings/general/story-settings',
                    roles: ['model'],
                    props: {
                        section: t('general'),
                        title: t('settings:storySettings'),
                        body: <StorySettings page='story-settings-main' />,
                        withoutHeaderSwitch: true
                    },
                    exact: true
                },
                {
                    path: '/settings/general/story-settings/who-can-see',
                    roles: ['model'],
                    props: {
                        section: t('settings:storySettings'),
                        title: t('whoCanSee'),
                        body: <StorySettings page='who-can-see' />
                    }
                }
            ],
            Component: SingleSetting
        },
        {
            path: '/settings/general/payout-settings/payment-method',
            Component: <PaymentMethod />,
            roles: ['model'],
            exact: true
        },
        {
            path: [
                {
                    path: '/settings/general/payout-settings/payment-method/wire',
                    roles: ['model'],
                    props: { page: 'wire' },
                    exact: true
                },
                {
                    path: '/settings/general/payout-settings/payment-method/ach',
                    roles: ['model'],
                    props: { page: 'ach' },
                    exact: true
                },
                {
                    path: '/settings/general/payout-settings/payment-method/paxum',
                    roles: ['model'],
                    props: { page: 'paxum' },
                    exact: true
                }
            ],
            Component: PaymentList
        },
        {
            path: '/settings/general/payout-settings/payment-method/wire/bank-information',
            Component: <BankInformation />,
            roles: ['model']
        },
        {
            path: '/settings/general/payout-settings/payment-method/ach/bank-information',
            Component: <BankInformation />,
            roles: ['model']
        },
        {
            path: '/settings/general/payout-settings/payment-frequency',
            Component: <PaymentFrequency />,
            roles: ['model']
        },
        {
            path: '/settings/general/payout-settings/upload-documents',
            Component: <UploadDocuments />,
            roles: ['model']
        },
        {
            path: '/settings/general/payout-settings/upload-documents/w9',
            Component: <W9 />,
            roles: ['model']
        },
         {
            path: '/settings/general/payout-settings/upload-documents/w8bene',
            Component: <W8Ben />,
            roles: ['model']
        },
         {
            path: '/settings/general/payout-settings/upload-documents/dac7',
            Component: <DAC7 />,
            roles: ['model']
        },
        {
            path: '/settings/general/profile-settings',
            Component: (
                <JustCheckboxCards
                    page='profile-settings'
                    main={t('general')}
                />
            ),
            roles: ['model'],
            exact: true
        },
        {
            path: '/settings/general/language',
            Component: <EditLanguage />,
            roles: ['model', 'fan']
        },
        {
            path: '/settings/general/wallet',
            Component: <Wallet />,
            roles: ['model', 'fan']
        },
        {
            path: '/settings/general/activity',
            Component: <Activity />,
            roles: ['model', 'fan']
        }
    ]
}
